import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Bugfender } from '@bugfender/sdk';
import './i18n';
import * as serviceWorker from './serviceWorker';
import App from './App';
import 'semantic-ui-css/semantic.min.css';
import 'react-toastify/dist/ReactToastify.min.css';
import './index.scss';
import configureStore from './redux/configureStore';

import { setAuthInterceptors, setHumpsInterceptors } from './interceptors/interceptors';
import { refreshingTokenFail, loginSuccess } from './redux/modules/auth';
import TOKEN from './constants';

const store = configureStore({});

setAuthInterceptors(() => store.dispatch(refreshingTokenFail()));
setHumpsInterceptors();

const token = localStorage.getItem(TOKEN);
if (token) {
  store.dispatch(loginSuccess());
}
if (process.env.NODE_ENV === 'production') {
  Bugfender.init({
    appKey: process.env.REACT_APP_BUGFENDER_KEY,
    apiURL: 'https://api.bugfender.com',
    baseURL: 'https://dashboard.bugfender.com',
    overrideConsoleMethods: false,
    printToConsole: false,
    registerErrorHandler: true,
    logBrowserEvents: false,
    logUIEvents: false,
    version: '',
    build: '',
  });
}

ReactDOM.render(
  <Suspense fallback="loading">
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </Suspense>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
